import { useMutation } from 'react-query';
import { client } from 'utils/api-client';

export default function useLogin() {
  return useMutation((values) =>
    client('auth/login/', { data: values }).then((res) => res)
  );
}
